import {useApi} from "@contexts/hooks/api/useApi.ts";
import {__orcamento_endpoints} from "@components/orcamento/endpoints/__orcamento_endpoints.ts";
import {IDataDto} from "@models/shared/IDataDto.ts";
import {IFormPagtoUpdateDto} from "@components/orcamento/models/IFormPagtoUpdateDto.ts";
import {ISolicitacaoOrcamento} from "@models/solicitacoes/orcamento.ts";
import {useValue} from "@components/shared/hooks/useValue.tsx";
import {OrcamentoAnexoType} from "@components/orcamento/CreateAnexoOrcamentoComponent.tsx";

export function useOrcamento() {
    const {Get} = useApi()

    const getItem = async (data: { idOrcamento: number }) => {
        return Get(__orcamento_endpoints.v2.item['get-item'](data))
    }
    const getOrcamento = (data: { idOrcamento: number }) => {
        return Get(__orcamento_endpoints.v2["get-orcamento"]({data}))
    }
    const finalizarOrcamento = async (data: { idOrcamento: number }) => {
        return Get(__orcamento_endpoints.v2["finaliza-orcamento"]({data: data} as IDataDto<{ idOrcamento: number }>))
    }
    const autorizarOrcamento = async (data: { idOrcamento: number }) => {
        return Get(__orcamento_endpoints.v2["autoriza-orcamento"]({data: data} as IDataDto<{ idOrcamento: number }>))
    }
    const efetuaCompra = async (data: { idOrcamento: number }) => {
        return Get(__orcamento_endpoints.v2["efetua-compra"]({data: data} as IDataDto<{ idOrcamento: number }>))
    }
    const efetuaPagamento = async (data: { idOrcamento: number }) => {
        return Get(__orcamento_endpoints.v2["efetua-pagamento"]({data: data} as IDataDto<{ idOrcamento: number }>))
    }
    const getFormaPagamento = async (data: { idOrcamento: number }) => {
        return Get(__orcamento_endpoints.v2["get-forma-pagamento"]({data: data}))
    }
    const getFormaPagtoFormsOrcamento = async (data: IDataDto<{ idOrcamento: number }>) => {
        return await Get(__orcamento_endpoints.v2["get-forma-pagto-forms"](data))
    }
    const updateFormaPagtoForms = async (data: IFormPagtoUpdateDto) => {
        return Get(__orcamento_endpoints.v2["update-forma-pagto-forms"]({data: data}))
    }

    const getArquivosOrcamento = async (data: IDataDto<{
        idOrcamento: number,
        tipos?: OrcamentoAnexoType[]
    }>) => {
        return await Get(__orcamento_endpoints.v2["get-arquivos"]({...data}))
    }

    const getAprovacoes = (data: IDataDto<{ idOrcamento: number }>) => {
        return Get(__orcamento_endpoints.v2["get-aprovacoes"](data))
    }

    return {
        getItem: getItem,
        getOrcamento: getOrcamento,
        finalizarOrcamento: finalizarOrcamento,
        autorizarOrcamento: autorizarOrcamento,
        efetuaPagamento: efetuaPagamento,
        getFormaPagamento: getFormaPagamento,
        efetuaCompra: efetuaCompra,
        getFormaPagtoFormsOrcamento: getFormaPagtoFormsOrcamento,
        updateFormaPagtoForms: updateFormaPagtoForms,
        getArquivosOrcamento: getArquivosOrcamento,
        getAprovacoes: getAprovacoes,
        useOrcamentoValue: (v: ISolicitacaoOrcamento | number) => useValue({
            value: v,
            getter: () => getOrcamento({idOrcamento: typeof v === 'number' ? v : v.id}),
        }),
    }
}
